import HomeIcon from '../../../assets/images/member-user-home.png';
import HomeActiveIcon from '../../../assets/images/member-user-home-active.png';
import UserIcon from '../../../assets/images/member-user-user.png';
import UserActiveIcon from '../../../assets/images/member-user-user-active.png';
import ActIcon from '../../../assets/images/member-user-activity.png';
import ActActiveIcon from '../../../assets/images/member-user-activity-active.png';
import pjpyIcon from '../../../assets/images/member-user-pjpy.png';
import pjpyActiveIcon from '../../../assets/images/member-user-pjpy-active.png';
import tgglIcon from '../../../assets/images/member-user-tggl.png';
import tgglActiveIcon from '../../../assets/images/member-user-tggl-active.png';
import fyzxIcon from '../../../assets/images/member-user-fyzx.png';
import fyzxActiveIcon from '../../../assets/images/member-user-fyzx-active.png';
import xxtzIcon from '../../../assets/images/member-user-xxtz.png';
import xxtzActiveIcon from '../../../assets/images/member-user-xxtz-active.png';
export const navList =  [{
  icon: HomeIcon,
  activeIcon: HomeActiveIcon,
  name: '会员首页',
  uri: ''
}, {
  icon: UserIcon,
  activeIcon: UserActiveIcon,
  name: '个人设置',
  children: [{
    name: '基本资料',
    uri: '?c=BaseInfo'
  }, {
    name: '个人证书',
    uri: '?c=PersonalCertificate',
    permission: (user) => user && user.memType === 'personal',
  }, {
    name: '团体证书',
    uri: '?c=OrgCertificate',
    permission: (user) => user && user.memType === 'org',
  },
  // {
  //   name: '修改密码'
  // }, {
  //   name: '企业认证'
  // },
   {
    name: '专题配置',
    permission: (user) => {
      return user && user.memType === 'org';
    },
    uri: '?c=ProjectSetting'
  }]
}, {
  icon: ActIcon,
  activeIcon: ActActiveIcon,
  name: '活动管理',
  children: [{
    name: '我的培训',
    uri: '?c=Activity&t=1'
  }, {
    name: '我的会议',
    uri: '?c=Activity&t=2'
  }, {
    name: '我的沙龙',
    uri: '?c=Activity&t=3'
  }]
}, {
  icon: pjpyIcon,
  activeIcon: pjpyActiveIcon,
  name: '等级评价',
  uri: '?c=Award'
}, {
  icon: tgglIcon,
  activeIcon: tgglActiveIcon,
  name: '投稿管理',
  uri: '?c=Report'
}, {
  icon: fyzxIcon,
  activeIcon: fyzxActiveIcon,
  name: '发票申请',
  uri: '?c=Invoice'
}, 
// {
//   icon: fyzxIcon,
//   activeIcon: fyzxActiveIcon,
//   name: '费用中心'
// }, 
{
  icon: xxtzIcon,
  activeIcon: xxtzActiveIcon,
  uri: '?c=Notify',
  name: '消息通知'
}];